import * as React from "react";
import { forwardRef } from "react";
const SvgRoundedSquare = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { width: 32, height: 32, rx: 8 }));
const ForwardRef = forwardRef(SvgRoundedSquare);
export default ForwardRef;
